import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Footer.css';

function Footer() {
  const location = useLocation();
  const navigate = useNavigate();

  // If visiting under /m (mobile shell), point footer links to mobile equivalents
  const base = location.pathname.startsWith('/m') ? '/m' : '';

  // Handle navigation to landing page sections (same logic as Header)
  const handleSectionNavigation = (sectionId) => {
    const isOnLandingPage = location.pathname === '/' || location.pathname === `${base}` || location.pathname === `${base}/`;

    if (isOnLandingPage) {
      // If already on landing page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      // If on another page, navigate to landing page with hash (respect mobile base)
      navigate(`${base}/#${sectionId}`);
    }
  };
  
  // Footer component - Support links removed as requested
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <div className="footer-logo-brand">
              <span className="footer-icon-wrap">
                <img src="/logos/DocuHounds logo-ICON1.png" alt="DocuHounds logo" className="footer-icon-img" />
              </span>
              <span className="footer-wordmark-wrap">
                <img src="/logos/DocuHounds logo-TEXT 3.png" alt="DocuHounds" className="footer-wordmark-img" />
              </span>
            </div>
            <p className="footer-tagline">
              Built by students, for students. DocuHounds is your trusted AI-powered academic companion that helps you stay organized, never miss deadlines, and succeed in your studies.
            </p>
            <div className="newsletter-signup">
              <h4>Stay Updated</h4>
              <p>Get the latest features and study tips delivered to your inbox.</p>
              <div className="newsletter-form">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  className="newsletter-input"
                />
                <button className="newsletter-btn">Subscribe</button>
              </div>
            </div>
            <div className="social-links">
              <a href="https://linkedin.com/company/docuhounds" aria-label="Connect on LinkedIn" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">💼</span>
              </a>
              <a href="https://youtube.com/@docuhounds" aria-label="Watch our YouTube channel" target="_blank" rel="noopener noreferrer">
                <span className="social-icon">📺</span>
              </a>
            </div>
          </div>
          
          <div className="footer-links">
            <div className="footer-column">
              <h4>Product</h4>
              <a href="#features" onClick={(e) => { e.preventDefault(); handleSectionNavigation('features'); }}>
                Features
              </a>
              <a href="#how-it-works" onClick={(e) => { e.preventDefault(); handleSectionNavigation('how-it-works'); }}>
                How It Works
              </a>
              <a href="#pricing" onClick={(e) => { e.preventDefault(); handleSectionNavigation('pricing'); }}>
                Pricing
              </a>
              <Link to={`${base}/blog`}>Blog</Link>
            </div>
            
            <div className="footer-column">
              <h4>Company</h4>
              <Link to={`${base}/about`}>About Us</Link>
              <Link to={`${base}/contact`}>Contact</Link>
              <Link to={`${base}/blog`}>Blog</Link>
            </div>
            
            <div className="footer-column">
              <h4>Legal</h4>
              <Link to={`${base}/privacy`}>Privacy Policy</Link>
              <Link to={`${base}/terms`}>Terms of Service</Link>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <p>&copy; 2025 DocuHounds Inc. All rights reserved.</p>
            <p className="footer-tagline-small">Empowering students worldwide</p>
          </div>
          <div className="footer-badges">
            <span className="badge students">🎓 Student-First</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
